//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { setOwnKey } from '@/tools'
import { mapGetters } from 'vuex'
import NumberInputSpinner from '@/components/vue-number-input-spinner/src/components/NumberInputSpinner.vue'

export default {
  props: {
    item: {
      type: Object,
      default: {
        v_ownId: setOwnKey(),
        v_editable: false,
        text: '选项1',
        score: 0,
        blankVisible: false,
        blankRule: 'ignore',
        blankMaxLengthVisible: false,
        blankMinLength: null,
        blankMaxLength: null,
        blankRequired: false,
      },
    },
  },
  computed: {
    ...mapGetters(['rules']),
  },
  components: {
    NumberInputSpinner,
  },
  methods: {
    minMaxBlur(type) {
      let min = this.item.blankMinLength
      let max = this.item.blankMaxLength
      if (max && min > max) {
        this.item.blankMaxLength = min
      }
    },
    filterRules(value) {
      let rules = this.rules
      let obj = {}
      rules.forEach((element) => {
        obj[element.value] = element.label
      })
      return value ? obj[value] : ''
    },
    ruleSetting() {
      new this.$Picker({
        data: [this.rules],
        value: this.item.blankRule,
        dataText: 'label',
        onOk: (values, text, selectedIndex) => {
          let rule = this.item.blankRule
          if (rule != values[0]) {
            this.item.blankMinLength = null
            this.item.blankMaxLength = null
          }
          this.item.blankRule = values[0]
        },
      })
    },
  },
}
